import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";

const BuyWithAutoComplete = ({ user, register, errors, setSelectedSymbol }) => {
    const [value, setValue] = useState()
    const [symbols, setSymbols] = useState([])

    const defProps = {
        options: symbols.map((option) => ({
            token: option?.token,
            symbol: option?.symbol,
            exchange: option?.exchange,
            name: option?.name
        })),
        getOptionLabel: (options) => options?.exchange + ":" + options?.symbol,
    }
    const getdata = (data) => {
        console.log(data);
        setSelectedSymbol(data)
    }

    useEffect(() => {
        if (value === null || value === undefined || value === "" || value.length < 2) {
            return
        }
        // to escape characters like '&' in url
        const queryParam = encodeURIComponent(value);
        fetch(`/algo-trading/api/symbols?symbol=${queryParam}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                'Authorization': user.credential,
            }
        }).then(resp => {
            return resp.json();
        }).then(res => {
            setSymbols(res)
        }).catch(e => {
            console.log(e.message);
        })

    }, [value])

    return (
        <>
            <Autocomplete
                {...defProps}
                isOptionEqualToValue={(option, value) => option.token === value.token}
                renderInput={(params) => (
                    <TextField {...params}
                        size={"small"}
                        label="Symbol"
                        variant="outlined"
                        value={value}
                        fullWidth={true}
                        placeholder={"Enter first 3 characters of symbol"}
                        error={errors && !!errors['symbol']}
                        helperText={errors && !!errors['symbol']?.message}
                        {...register?.('symbol', { required: true })}
                        onChange={(e) => setValue(e.target.value)} />
                )}
                onChange={(event, value) => getdata(value)}
                key={"2"}
            >
            </Autocomplete>
        </>
    );
}

export default BuyWithAutoComplete;